import styles from './AceDividerCard.module.css';
import { ReactNode } from 'react';

export const AceDividerCard = ({
  title,
  children,
}: {
  title?: string;
  children: ReactNode;
}) => {
  return (
    <div className={styles.container}>
      {title && (
        <div className={styles.header}>
          <h3 className={styles.headerText}>{title}</h3>
        </div>
      )}
      {children}
    </div>
  );
};
